var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-input-base-text',_vm._b({attrs:{"format-down":_vm.formatDown,"format-up":_vm.formatUp,"on-focus":_vm.setInitialValue,"is-invalid":_vm.isInvalid,"type":'tel',"inputmode":"numeric","pattern":"\\\\d*","is-phone":""},on:{"input":_vm.inputHandler}},'ui-input-base-text',{ ..._vm.model },false))
}
var staticRenderFns = []

export { render, staticRenderFns }